import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const NotFound = lazy(() => import('../../container/pages/404'));
const EditSystemSettingForm = lazy(() => import('../../container/systemSettings/EditSystemSettingsForm'));
const SystemSettingsList = lazy(() => import('../../container/systemSettings'));

function SystemSettingsRoute() {
  return (
    <Routes>
      <Route path="/" element={<SystemSettingsList />} />
      <Route path="/:id/edit" element={<EditSystemSettingForm />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default SystemSettingsRoute;
